export const FACTION_SKIN_DEFAULT_TYPE = 'default';

// Валюта покупки обличия (она же — currency в записи покупки на сервере)
export const FACTION_SKIN_CURRENCIES = {
  NUMENS: 'numens',
  CRYSTALS: 'crystals',
};
